const s = {
  name: "UserWarning",
  dimensions: { width: 38, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 40" style="enable-background:new 0 0 38 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,0c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S22.4,0,18,0z M12,8c0-3.3,2.7-6,6-6s6,2.7,6,6c0,3.3-2.7,6-6,6
			S12,11.3,12,8z"/>
		<path class="st0" d="M11,18C4.9,18,0,22.9,0,29v11h2V29c0-5,4-9,9-9h7v-2H11z"/>
		<path class="st0" d="M6,40V30h2v10H6z"/>
		<path class="st0" d="M28.5,35c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5S28.5,34.2,28.5,35z"/>
		<path class="st0" d="M28,26v6h-2v-6H28z"/>
		<path class="st0" d="M27,20c-1,0-1.9,0.5-2.4,1.3l-8,13.3l0,0C16.2,35.3,16,36.2,16,37c0,1.7,1.3,3,3,3h16c1.7,0,3-1.3,3-3
			c0-0.8-0.2-1.7-0.7-2.4l-8-13.3C28.9,20.5,28,20,27,20z M26.4,22.4c0.1-0.2,0.4-0.4,0.6-0.4s0.5,0.1,0.6,0.4l8,13.3l0,0
			c0.2,0.4,0.4,0.9,0.4,1.3c0,0.5-0.5,1-1,1H19c-0.5,0-1-0.5-1-1c0-0.5,0.1-0.9,0.4-1.3L26.4,22.4L26.4,22.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserWarning
};
